export const PATH_SLIPS = `/slips`;

export function fetchSlipHistory(slipId) {
  return this.http.get(`${PATH_SLIPS}/${slipId}/history`);
}
